import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/data/content";

export const MarqueeStrip = () => (
  <div data-testid="marquee" className="border-y border-white/10 bg-[#080808] py-8 overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl text-white/25 px-8">
            {item}
          </span>
          <span className="text-[#d4af37] text-xl">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
